import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { FormUser } = Forms
        const { onResetForm } = FormUser

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchAllUsers = async () => {

        const { fetchAllUsers } = FetchData
        const { executeFetch } = fetchAllUsers

        executeFetch()

    }

    const handleClickFetchSpecificUser = async (idusuario) => {
        
        const { FormUser: {onResetForm} } = Forms

        const { fetchSpecificUser } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificUser

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idusuario: idusuario})
        executeFetch()

        handleClickShowForm(true)

    }

    const handleClickEnableUser = async (idusuario) => {
        Swal.fire({
            title: '¿Está seguro de Activar este registro?',
            text: 'Esta acción hará que el registro vuelva a mostrarse en los listados de clientes que se encuentran en todo el sistema y podrá asociar información a él nuevamente',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/users/enable/${idusuario}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllUsers()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickDisableUser = async (idusuario) => {
        Swal.fire({
            title: '¿Está seguro de Desactivar este registro?',
            text: 'Esta acción hará que el registro sea removido de los listados de clientes que se encuentran en todo el sistema y no podrá asociar información a él',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/users/disable/${idusuario}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllUsers()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickDeleteUser = async (idusuario) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/users/delete/${idusuario}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllUsers()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }

    const handleChangeUserName = async (e) => {

        const { name, value } = e.target

        const { FormUser } = Forms
        const { setFormState } = FormUser

        setFormState(prevState => ({
            ...prevState,
            [ name ]: value,
            userNameMessage: ''
        }))

        const regex = /^[a-z0-9.]+$/
        if (!regex.test(value)) {
            setFormState(prevState => ({
            ...prevState,
                userNameMessage: 'El nombre de usuario no es valido, contiene espacios, mayúsculas o caractéres especiales, si necesita separar texto hagalo con un punto.'
            }))
            return
        }

        
    }
    
    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { FormUser } = Forms
        const { formState, onResetForm } = FormUser

        if (formState.userpassword.includes(' ')){
            const messageCustom = {
                message: 'La contraseña no puede tener espacios',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        const _dataBody = {
            idusuario: formState.idusuario,
            nombreusuario: formState.nombreusuario,
            nombre: formState.nombre,
            apellido: formState.apellido,
            email: formState.email,
            userpassword: formState.userpassword,
            usuario_creo: user.username,
            fecha_creo: new Date()
        }

        const regex = /^[a-z0-9.]+$/
        if (!regex.test(formState.nombreusuario)) {
            toast.warn('El nombre de usuario no es valido, contiene espacios, mayúsculas o caractéres especiales, si necesita separar texto hagalo con un punto.', {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
            return
        }

        if(_dataBody.idusuario > 0){

            await marvarApi.put( `/users/update/${_dataBody.idusuario}`, _dataBody )
                .then(({ data }) => {

                    alertMessage(data)
                    onResetForm()
                    handleClickFetchAllUsers()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }else{

            await marvarApi.post( `/users/create`, _dataBody )
                .then(({ data }) => {
                    
                    alertMessage(data)
                    onResetForm()
                    handleClickFetchAllUsers()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const handleClickPermissionsModal = async (_, title, compont, dataRequest) => {

        const { FormPermissionAssignment } = Forms
        const { setFormState, onResetForm } = FormPermissionAssignment

        const { fetchPermissionsByUser } = FetchData

        // Limpiar permisos anteriores antes de cargar los del nuevo usuario
        onResetForm()
        fetchPermissionsByUser.resetFetch()

        fetchPermissionsByUser.setParamsToSearch({
            idusuario: dataRequest.data.idusuario,
            fetchAssignmentInfo: {
                flag: true,
                refSetFormState: setFormState,
                formStateArrayName: 'permissionsAssigned'
            }
        })
        fetchPermissionsByUser.executeFetch()

        abrirModal(_, title, compont, dataRequest)
    }

    const handleChangePermissionAssignment = (formStateArrayName, idpermiso) => {


        const { FormPermissionAssignment } = Forms
        const { formState, setFormState } = FormPermissionAssignment

        const togglePermissions = (perms) =>
            perms.map((permiso) => {
                if (permiso.idpermiso === idpermiso) {
                    return { ...permiso, is_assigned: !permiso.is_assigned };
                }
                if (permiso.hijos && permiso.hijos.length > 0) {
                    return { ...permiso, hijos: togglePermissions(permiso.hijos) };
                }
                return permiso;
            }
        )
        setFormState(prevState => ({
            ...prevState,
            [ formStateArrayName ]: togglePermissions(formState[ formStateArrayName ])
        }))
        
    }

    const onSubmitPermissionAssignmentForm = async (e, idusuario) => {
        e.preventDefault()

        const { setLoadingSubmitForm } = globalStates
        const { extractPermissionsSelected } = Helpers
        const { FormPermissionAssignment } = Forms
        const { formState, onResetForm } = FormPermissionAssignment

        console.log("[useActions][onSubmitPermissionAssignmentForm] formState.permissionsAssigned", formState.permissionsAssigned);
        const extractedPermissions = extractPermissionsSelected(formState.permissionsAssigned);
        console.log("[useActions][onSubmitPermissionAssignmentForm] extractedPermissions", extractedPermissions);

        const _dataBody = {
            idusuario: idusuario,
            usuario_creo: user.username,
            fecha_creo: new Date(),
            permissionsAssigned: extractedPermissions.map((item) => ({
                idpermiso: parseInt(item.idpermiso, 10)
            }))
        }

        console.log('[useActions][onSubmitPermissionAssignmentForm] _dataBody ::: ',_dataBody)

        setLoadingSubmitForm(true)
        await marvarApi.post( `/users/save-permission-assignment`, _dataBody )
            .then(({ data }) => {

                alertMessage(data)
                onResetForm()
                handleClickFetchAllUsers()
                toggle()

                setLoadingSubmitForm(false)
                
            })
            .catch(error => {
                console.log('API ERROR: ', error)
                setLoadingSubmitForm(false)
            })
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllUsers,
        handleClickFetchSpecificUser,
        handleClickEnableUser,
        handleClickDisableUser,
        handleClickDeleteUser,
        handleChangeUserName,
        onSubmitForm,
        handleClickPermissionsModal,
        handleChangePermissionAssignment,
        onSubmitPermissionAssignmentForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}